export default __webpack_public_path__ + "static/GT-Super-Display-Regular-Italic-75d9687caf3cac5be25788e91e5e70fc.woff2";